import type { IClientAction } from '@/entities/client.entity';
import { cn } from '@/lib/utils';
import { CheckCircleIcon, ClockIcon, LoaderIcon, XCircleIcon } from 'lucide-react';

function getCommandStatus(action: IClientAction) {
	if (action.status === 0) {
		return { label: 'В очереди', icon: ClockIcon, className: 'text-muted-foreground', pulse: false };
	}
	if (action.status === 1) {
		return { label: 'На устройстве', icon: LoaderIcon, className: 'text-chart-5', pulse: true };
	}
	if (action.status === 3) {
		return { label: 'Ошибка', icon: XCircleIcon, className: 'text-destructive', pulse: false };
	}
	return { label: 'Выполнена', icon: CheckCircleIcon, className: 'text-chart-2', pulse: false };
}

interface CommandStatusBadgeProps {
	action: IClientAction;
	className?: string;
}

export default function CommandStatusBadge({ action, className }: CommandStatusBadgeProps) {
	const status = getCommandStatus(action);
	const StatusIcon = status.icon;

	return (
		<span
			className={cn(
				'inline-flex items-center gap-1 rounded-full border border-border bg-background/80 px-2 py-0.5 text-xs font-medium',
				status.className,
				status.pulse && 'animate-pulse',
				className,
			)}
		>
			<StatusIcon size={12} className={status.pulse ? 'animate-spin' : undefined} />
			{status.label}
		</span>
	);
}
